import { EEntity } from '../enums/entity.enum';
import { IRelateTo } from '@/shared/interfaces/relate-to.interface';

export const relateToEntityMapper = <T extends Record<string, any>>(
  data: T,
  type: EEntity,
): IRelateTo => {
  switch (type) {
    case EEntity.ACCOUNT:
      return {
        value: data.accountid,
        label: data.name,
      };

    case EEntity.CONTACT:
      return {
        value: data.contactid,
        label: data.fullname,
      };

    case EEntity.LEAD:
      return {
        value: data.leadid,
        label: data.fullname,
      };

    case EEntity.OPPORTUNITY:
      return {
        value: data.opportunityid,
        label: data.name,
      };

    case EEntity.CASE:
      return {
        value: data.incidentid,
        label: data.title,
      };

    case EEntity.CAMPAIGN:
      return {
        value: data.campaignid,
        label: data.name,
      };

    case EEntity.QUOTE:
      return {
        value: data.quoteid,
        label: data.name,
      };

    case EEntity.INVOICE:
      return {
        value: data.invoiceid,
        label: data.name,
      };

    case EEntity.ORDER:
      return {
        value: data.salesorderid,
        label: data.name,
      };
  }
};
